import React from 'react';

import { SVGPropsType } from 'src/types';

const CrossCircle = (props: SVGPropsType) => {
    const { fill, stroke, onClick, style, className } = props;
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                fill={fill}
            />
            <path
                d="M10 6L6 10"
                stroke={stroke}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 6L10 10"
                stroke={stroke}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CrossCircle;
